const HERO_SELECTOR = '.hero[data-hero-intro="true"]';
const READY_ATTR = 'data-hero-intro-ready';

const shouldReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const isDesignMode = document.documentElement.classList.contains('shopify-design-mode');

function activateHeroIntro(root = document) {
  const hero = root.querySelector(HERO_SELECTOR);

  if (!(hero instanceof HTMLElement)) return;

  if (shouldReduceMotion || isDesignMode) {
    hero.setAttribute(READY_ATTR, 'true');
    return;
  }

  hero.removeAttribute(READY_ATTR);

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      hero.setAttribute(READY_ATTR, 'true');
    });
  });
}

function initHeroIntro() {
  activateHeroIntro();

  document.addEventListener('shopify:section:load', (event) => {
    if (!(event.target instanceof HTMLElement)) return;

    if (event.target.matches('.hero-wrapper')) {
      activateHeroIntro(event.target);
    }
  });

  window.addEventListener('pageshow', () => {
    activateHeroIntro();
  });

  window.addEventListener('pagereveal', () => {
    activateHeroIntro();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroIntro, { once: true });
} else {
  initHeroIntro();
}
